// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__tD-A+","plusContainer":"styles_plusContainer__Ojr7p","plus":"styles_plus__yQREQ","badgesDisplay":"styles_badgesDisplay__VqzWT","text":"styles_text__hQBNM"};